import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Apiservice } from '../../services/api.service';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { NicaplayerComponent } from '../../nicaplayer/nicaplayer.component';
import { ComponentService } from '../../services/component.service';
import { messagefromComponent } from '../../class/appinterface';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';

//import { IVideoConfig } from "ngx-video-list-player";


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  @ViewChild('videoPlayerNica', { static: false }) videoPlayerNica: NicaplayerComponent;
  imageToShow: any;
  imageWinwaste;
  winwaste
  socketTv: any={is_live:false};
  azienda: any;
  live_winwaste: any;
  linkDiretta: any;
  constructor(
    private httpBackend: HttpBackend,
    private userComponentService: ComponentService,
    private sanitizer:DomSanitizer,private router:Router,private appService: Apiservice,) { 
      
    }
  onCustomEvent(response: any): void {
    //this.imageWinwaste:this.safeResourceUrl;
    this.socketTv=response
    //this.socketTv.is_live=true;
    //console.log("In Home Component ",this.socketTv);
  }
 
  saniticeImg(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' +url);
  }





  messaggioFromComponent(message: messagefromComponent) {
    //
   if(message.codeMessage==89){
    this.socketTv.is_live=message.value.is_live
    //console.log("Ecco live in home messaggio",message.value)
   }
}

  ngOnInit() {
    
//    this.userComponentService.castMessage.subscribe((message: messagefromComponent) => this.messaggioFromComponent(message));

  this.userComponentService.castMessage.subscribe(
  (message:messagefromComponent)=>{
    if(message.codeMessage==89){
      this.socketTv=message.value
      //console.log("Ecco live in home messaggio",this.socketTv)
     }
      
  })

    //console.log("ON INITTTTTTTTTTTTTTTTTTTTT")
    this.winwaste={
      link:''
    }
    this.appService.GetExternalApiBackEnd("https://www.ricicla.tv/admin/laravel/api/auth/winwaste").then(data=>{     
      this.imageWinwaste=data.data.winwaste_title
      this.winwaste=data.data;
      //console.log("ecco dati ",this.winwaste.link)
    })

    this.appService.GetExternalApiBackEnd("https://www.ricicla.tv/admin/laravel/api/auth/aziendaByName/riciclatv").then(data=>{     
      this.azienda=data.data
      this.live_winwaste=this.azienda.winwaste;
      this.linkDiretta=this.azienda.linkdiretta;//'https://vimeo.com/event/1698194'
      this.linkDiretta+='/embed?autoplay=1&loop=0&muted=1';
      //this.linkDiretta='https://www.youtube.com/watch?v=u4IFd9yrIb0'
      //console.log("ecco AZIENDA ",this.azienda)
      //this.videoPlayerNica.settaUrl(this.linkDiretta);

    })

    //admin/laravel/api/auth/aziendaByName/riciclatv
    /*this.router.navigate(["main/dashboard"], {queryParams:{
     
      api:"",
      componentName:"DashboardComponent",
      currentTabId:"0",
      currentTabName:"Dashboard",
      data:{},
      queryFilter:{},
      service:"",
      helpDoc:""

      },
      skipLocationChange: true,
      replaceUrl: true
    })*/


  }

}
